import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RadContainer } from '../common/RadContainer'
import { RadHeader } from '../common/RadHeader'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { RadBox } from '../common/RadBox'
import { RadExternalLink } from '../common/RadExternalLink'
import { RadBadge } from '../common/RadBadge'
import { RadButton } from '../common/RadButton'

export function CollectionDetailContent ({ collection, closeModal }) {
  const navigate = useNavigate()

  if (collection == null) {
    return null
  }

  const resources = collection.resources ?? []
  const resourceCount = collection.resourceCount ?? resources.length

  return (
    <RadBox margin={{ top: 'l' }}>
      <RadSpaceBetween size='l'>
        <RadContainer
          className='collection-detail-container'
          key='details'
          header={
            <RadHeader variant='h3'>
              {collection.isFeatured && <RadBadge key='badge' featured>Featured</RadBadge>}
              <RadHeader key='heading' variant='h2'>Details</RadHeader>
            </RadHeader>
          }
        >
          <RadSpaceBetween size='m'>
            <RadBox key='subtitle'>
              <strong>Subtitle:</strong> {collection.subtitle}
            </RadBox>
            <RadBox key='description'>
              <strong>Description:</strong> {collection.description}
            </RadBox>
            {collection.featuredBlogPostName && collection.featuredBlogPostUrl && (
              <RadBox key='featured-blog-post'>
                <strong>Featured Blog Post:</strong>{' '}
                <RadExternalLink href={collection.featuredBlogPostUrl}>
                  {collection.featuredBlogPostName}
                </RadExternalLink>
              </RadBox>
            )}
          </RadSpaceBetween>
        </RadContainer>

        <RadContainer
          key='resources'
          header={
            <RadHeader
              variant='h3'
              counter={`(${resourceCount})`}
            >
              Resources
            </RadHeader>
          }
        >
          <RadBox textAlign='center'>
            <RadButton
              onClick={() => {
                // Close the (state-controlled) modal when rendered inside one,
                // otherwise it stays open over the filtered list and the
                // navigation appears to do nothing.
                if (closeModal != null) { closeModal() }
                navigate(`/resource?collectionId=${collection?.id}`)
              }}
              iconName='search'
              iconAlign='left'
              className='font-size-12'
            >
              Browse Collection ({resourceCount})
            </RadButton>
          </RadBox>
        </RadContainer>
      </RadSpaceBetween>
    </RadBox>
  )
}
